import React, { useEffect } from 'react';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const myPayoutPageContext = React.createContext({});
export let myPayoutPageMachine: any;

const MODULE_NAME = 'machines.pageContent';

export const useSMmyPayoutPage = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  myPayoutPageMachine = createMachine(_machineConfig, { services, actions });
  const [state, send] = useMachine(myPayoutPageMachine);

  useEffect(() => {
    send({ type: 'START' });
  }, []);

  return {
    myPayoutPageMachine,
    myPayoutPageState: state,
    myPayoutPageSend: send,
  };
};
